PaymentMethodsController.$inject = ['$transitions', 'CorporateService', '$rootScope']

export default function PaymentMethodsController($transitions, CorporateService, $rootScope) {
  var vm = this
  
  $transitions.onBefore({}, () => {
    
  }, {invokeLimit: 1})
}